import { render } from "./ContactsBtnListCard.vue?vue&type=template&id=1793a337&scoped=true"
import script from "./ContactsBtnListCard.vue?vue&type=script&lang=js"
export * from "./ContactsBtnListCard.vue?vue&type=script&lang=js"

import "./ContactsBtnListCard.vue?vue&type=style&index=0&id=1793a337&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1793a337"]])

export default __exports__